export default __webpack_public_path__ + "static/pexels-egor-kamelev-1114318_-3d8b4c7171859f69c2aa713f4d424d3e.jpg";